/**
 * Listing sales service: read from listing_sales table (marketplace sales).
 * Backend: GET /api/listing-sales (optional filters), GET /api/listing-sales/{id}.
 */
import axios from 'axios';
import { authHeaders } from './apiAuth';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

/**
 * Get all listing sales, optionally filtered. Each row includes product_id, product_name, remaining_available.
 * @param {string} accessToken - User's JWT
 * @param {{ listing_id?: number, marketplace_order_id?: string, product_name?: string }} [params] - Optional filters
 * @returns {Promise<{ success: boolean, listing_sales?: Array<object>, error?: string }>}
 */
export const getListingSales = async (accessToken, params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.listing_id != null) queryParams.set('listing_id', String(params.listing_id));
    if (params.marketplace_order_id != null) queryParams.set('marketplace_order_id', params.marketplace_order_id);
    if (params.product_name != null && String(params.product_name).trim() !== '') {
      queryParams.set('product_name', String(params.product_name).trim());
    }
    const url = `${API_BASE_URL}/api/listing-sales${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const response = await axios.get(url, { headers: authHeaders(accessToken) });
    return response.data;
  } catch (error) {
    const detail = error.response?.data?.detail;
    const message = typeof detail === 'string' ? detail : detail?.message || 'Failed to get listing sales';
    throw new Error(message);
  }
};

/**
 * Get one listing sale by id.
 * @param {string} accessToken - User's JWT
 * @param {number} saleId - listing_sales.id
 * @returns {Promise<{ success: boolean, listing_sale?: object, error?: string }>}
 */
export const getListingSaleById = async (accessToken, saleId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/api/listing-sales/${saleId}`, {
      headers: authHeaders(accessToken)
    });
    return response.data;
  } catch (error) {
    const detail = error.response?.data?.detail;
    const message = typeof detail === 'string' ? detail : detail?.message || 'Failed to get listing sale';
    throw new Error(message);
  }
};
